<template>
  <div data-cy="conflict-notes-field">
    <LlTextarea
      :id="id"
      :model-value="modelValue"
      label="Notes"
      label-class="text-sm font-medium"
      :rows="4"
      :disabled="disabled"
      placeholder="What you concluded: which results you cleared and why, and what you escalated."
      data-cy="conflict-notes-input"
      @update:model-value="emit('update:modelValue', $event ?? '')"
    />
    <div class="mt-1 flex flex-wrap items-baseline justify-between gap-2">
      <span
        v-if="overLimit"
        class="text-xs font-medium text-error"
        aria-live="polite"
        data-cy="conflict-notes-over-limit"
      >
        Notes are limited to {{ limitLabel }} characters. You have
        {{ countLabel }}.
      </span>
      <span v-else class="text-xs text-gray-500">
        One note for the whole check, in your own words.
      </span>
      <span
        class="ml-auto text-xs tabular-nums"
        :class="overLimit ? 'font-medium text-error' : 'text-gray-500'"
        data-cy="conflict-notes-count"
      >
        {{ countLabel }} / {{ limitLabel }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import LlTextarea from '@/components/LlTextarea.vue';
import { CONFLICT_NOTES_MAX_LENGTH } from '../constants/conflictRecordConstants';

const props = defineProps<{
  modelValue: string;
  id: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{ 'update:modelValue': [value: string] }>();

const count = computed(() => props.modelValue.length);
const overLimit = computed(() => count.value > CONFLICT_NOTES_MAX_LENGTH);
const countLabel = computed(() => count.value.toLocaleString('en-US'));
const limitLabel = CONFLICT_NOTES_MAX_LENGTH.toLocaleString('en-US');
</script>
